
import { toast } from 'react-toastify';

import { AlertMessage } from '@components/ui/Alert/AlertMessage';

export const alert = (message: string) => {
  return toast<string>(<AlertMessage>{message}</AlertMessage>, {
    style: { backgroundColor: 'unset', boxShadow: 'unset', padding: 0 },
  });
};

alert.success = (message: string) => {
  return toast<string>(
    <AlertMessage severity='success'>{message}</AlertMessage>,
    {
      type: 'success',
      style: { backgroundColor: 'unset', boxShadow: 'unset', padding: 0 },
    },
  );
};

alert.info = (message: string) => {
  return toast<string>(<AlertMessage severity='info'>{message}</AlertMessage>, {
    type: 'info',
    style: { backgroundColor: 'unset', boxShadow: 'unset', padding: 0 },
  });
};

alert.warning = (message: string) => {
  return toast<string>(
    <AlertMessage severity='warning'>{message}</AlertMessage>,
    {
      type: 'warning',
      style: { backgroundColor: 'unset', boxShadow: 'unset', padding: 0 },
    },
  );
};

alert.error = (message: string) => {
  return toast<string>(
    <AlertMessage severity='error'>{message}</AlertMessage>,
    {
      type: 'error',
      style: { backgroundColor: 'unset', boxShadow: 'unset', padding: 0 },
    },
  );
};
